import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-initial',
  templateUrl: './login-initial.component.html',
  styleUrls: ['./login-initial.component.scss']
})
export class LoginInitialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
